import React from 'react';
import { ChevronLeft, ChevronRight, Code2, Search, FileText, UserCircle } from 'lucide-react';
import './Sidebar.css';

interface SidebarProps {
  collapsed: boolean;
  mobileOpen?: boolean;
  onToggleCollapse: () => void;
  selectedLanguage: string;
  onLanguageSelect: (language: string) => void;
}

const languages = [
  { id: 'javascript', name: 'JavaScript', icon: '🟨' },
  { id: 'python', name: 'Python', icon: '🐍' },
  { id: 'typescript', name: 'TypeScript', icon: '🔷' },
  { id: 'java', name: 'Java', icon: '☕' },
  { id: 'cpp', name: 'C++', icon: '⚡' },
  { id: 'go', name: 'Go', icon: '🔵' },
  { id: 'rust', name: 'Rust', icon: '🦀' },
  { id: 'php', name: 'PHP', icon: '🐘' },
];

const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  mobileOpen = false,
  onToggleCollapse,
  selectedLanguage,
  onLanguageSelect
}) => {
  const [searchQuery, setSearchQuery] = React.useState('');

  const filteredLanguages = languages.filter(lang =>
    lang.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''} animate-fade-in`}>
      <div className="sidebar-header">
        <button className="collapse-btn" onClick={onToggleCollapse}>
          {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
        {!collapsed && <span className="sidebar-title">Menu</span>}
      </div>

      <div className="sidebar-content">
        <div className="sidebar-section">
          <div className="sidebar-item active">
            <Code2 size={18} />
            {!collapsed && <span>Code Generation</span>}
          </div>

          <div className="sidebar-item search-item">
            <Search size={18} />
            {!collapsed && (
              <input
                className="sidebar-search-input"
                placeholder="Search languages..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            )}
          </div>
        </div>

        {!collapsed && (
          <div className="sidebar-section">
            <div className="section-title">Languages</div>
            <div className="languages-list">
              {filteredLanguages.length > 0 ? (
                filteredLanguages.map((lang, idx) => (
                  <div
                    key={lang.id}
                    className={`language-item ${selectedLanguage === lang.id ? 'active' : ''} animate-slide-up`}
                    style={{ animationDelay: `${idx * 0.05}s` }}
                    onClick={() => onLanguageSelect(lang.id)}
                  >
                    <span className="language-icon">{lang.icon}</span>
                    <span className="language-name">{lang.name}</span>
                  </div>
                ))
              ) : (
                <div className="no-results">No languages found</div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;